export function buildBaiduMarkerLink({ lat, lng, title, address }) {
	return (
		'https://api.map.baidu.com/marker' +
		`?location=${lat},${lng}` +
		`&title=${encodeURIComponent(title)}` +
		`&content=${encodeURIComponent(address)}` +
		'&output=html' +
		'&src=webapp.jet-voice'
	)
}

export function isMobileDevice() {
	if (typeof navigator === 'undefined') return false
	return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
}

function isIOS() {
	return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}

function buildNativeMapLink({ lat, lng, title, address }) {
	const query = encodeURIComponent(`${title} ${address}`)
	if (isIOS()) {
		return `https://maps.apple.com/?ll=${lat},${lng}&q=${query}`
	}
	return `geo:${lat},${lng}?q=${query}`
}

export function openAddressMap({ lat, lng, title, address, isMobile }) {
	const webLink = buildBaiduMarkerLink({ lat, lng, title, address })
	const mobile = isMobile || isMobileDevice()

	if (!mobile) {
		window.open(webLink, '_blank', 'noopener,noreferrer')
		return
	}

	const ok = window.confirm('是否使用手机地图打开该地点？')
	if (!ok) return

	const nativeLink = buildNativeMapLink({ lat, lng, title, address })
	const start = Date.now()
	window.location.href = nativeLink

	setTimeout(() => {
		if (document.hidden) return
		if (Date.now() - start < 1800) {
			window.location.href = webLink
		}
	}, 1200)
}
